import { makeStyles } from '@mui/styles';
import CheckBox from 'apollo-react/components/Checkbox';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { getUITA, isTrue } from '../../utils/commonUtils';

const useStyles = makeStyles({
  disabled: {
    '& .Mui-disabled svg': {
      fill: 'currentColor !important',
    },
  },
});

const SSCheckbox = ({
  label,
  actions,
  className,
  isRequired,
  value = false,
  error,
  inTable,
  instanceId,
  entityName,
  fieldName,
  isEditor,
  isViewOnly,
  disabled,
}) => {
  const classes = useStyles();
  const [newValue, setValue] = useState(isTrue(value));

  // Update inner state when `value` is changed from outside.
  useEffect(() => {
    setValue(isTrue(value));
  }, [value]);

  const onChange = ({ target: { checked } }) => {
    actions.updateControlValue(checked);
  };

  return (
    <CheckBox
      id={instanceId}
      label={inTable ? '' : label}
      checked={newValue}
      className={classNames(className, isEditor && classes.disabled)}
      onChange={onChange}
      required={isRequired}
      error={error}
      disabled={isEditor || isViewOnly || disabled}
      ui-ta={getUITA('FormCtrl', 'SSCheckbox', entityName, fieldName)}
      aria-label={fieldName}
    />
  );
};

export default SSCheckbox;
